export default {
  pageTitle: '',
  pageDesc: '',
  pageLang: 'en',
  theme: 'default',
  splashPage: false,
  menuVisible: false,
  store: localStorage.rma_store,
  country: 0,
  step: 0,
  prodList: [],
  orderSelectedCount: 0,
  retailSelectedCount: 0,
  pageLoading: false,
  dropMenuVisible: false,
  dropMenu: {},
  productFaultInfo: {}
}
